import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import ShareLinks from '~/components/UIComponents/ShareLinks.vue';
import { useSanityShareLinks } from '~/composables/useShareLinks';
import { SanityDocumentSchema } from '~/types/sanity-documents';
import { ISanityObjects, SanityObjectSchema } from '~/types/sanity-objects';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromoBoxShare',
  props: {
    heading: null,
    slug: null,
    schema: null,
    utmContent: null
  },
  setup(__props: any) {

const props = __props as {
  heading?: string;
  slug: string;
  schema: SanityDocumentSchema;
  utmContent?: ISanityObjects[SanityObjectSchema.UTM_CONTENT];
};



const utmName = 'gf-share-mb';
const shareParams = computed(() => ({
  slug: props.slug,
  schema: props.schema,
  utmCampaign: utmName,
  utmContent: props.utmContent?.keyValuePairs
    ? props.utmContent?.keyValuePairs
    : '',
  utmName,
}));

const {
  url: shareUrl,
  facebook: shareFacebook,
  twitter: shareTwitter,
} = useSanityShareLinks(shareParams);

return { __sfc: true,props, utmName, shareParams, shareUrl, shareFacebook, shareTwitter, ShareLinks }
}

})